module.exports = __webpack_public_path__ + "img/sample-ktp-1.f330b61b.png";